import { pipe, of, forkJoin } from 'rxjs';
import { map, filter, switchMap, take } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Fetch } from '@app/models/fetch';
import { Location, LocationAppliances } from '@app/models/locations/locations.model';
import { HeaderState, ChangeLocation } from '@app/header/header.state';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../../header/header.state";
import * as i3 from "@ngxs/store";
export class LocationService {
    constructor(fetch, headerState, store) {
        this.fetch = fetch;
        this.headerState = headerState;
        this.store = store;
        this.baseUrl = '/locations';
    }
    getCurrent() {
        return this.headerState.getLocation().pipe(take(1));
    }
    get(id) {
        return this.fetch.getOne(this.baseUrl, id).model(Location);
    }
    getSome(ids) { }
    getAll(options) {
        return this.fetch.getAll(this.baseUrl, options).models(Location);
    }
    create(loc) {
        return this.fetch.post('/locations', loc);
    }
    update(id, loc) {
        return this.fetch.patch('/locations', id, loc).pipe(switchMap((res) => this.headerState.getLocation()), switchMap((currLoc) => {
            if (id === currLoc.id) {
                return this.get(id).pipe(switchMap((newLoc) => this.store.dispatch(new ChangeLocation(newLoc))));
            }
            return of(currLoc);
        }));
    }
    joinDevice(device) {
        return this.get(device.location_id).pipe(map((location) => {
            device.location = location;
            return device;
        }));
    }
    joinDevices(devices) {
        return this.fetch
            .getSome(this.baseUrl, devices.map((device) => device.location_id))
            .models(Location)
            .pipe(map((locs) => {
            for (let i = 0; i < devices.length; i++) {
                devices[i].location = locs[i];
            }
            return devices;
        }));
    }
    joinDevicesPipe() {
        return pipe(switchMap((devices) => this.joinDevices(devices)));
    }
    joinNotificationFromDevice(notif) {
        return this.get(notif.device.location_id).pipe(map((location) => {
            notif.location = location;
            return notif;
        }));
    }
    joinNotificationsFromDevicesPipe() {
        return pipe(filter((notifs) => !notifs.find((notif) => !notif.device)), switchMap((notifs) => {
            if (notifs.length === 0) {
                return of(notifs);
            }
            return forkJoin(notifs.map((notif) => this.joinNotificationFromDevice(notif)));
        }));
    }
    getUsageProfileAppliances() {
        return this.fetch.get('//location-profiles').model(LocationAppliances);
    }
}
LocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationService_Factory() { return new LocationService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.HeaderState), i0.ɵɵinject(i3.Store)); }, token: LocationService, providedIn: "root" });
